import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const getRefreshToken =
    async (): Promise<AccountModel.PostRefreshTokenResponse> => {
        let response: AccountModel.PostRefreshTokenResponse;

        try {
            response =
                await Http.Request<AccountModel.PostRefreshTokenResponse>({
                    method: "POST",
                    url: "/account/refresh-token",
                });
        } catch (error) {
            // @ts-ignore
            throw Error(error);
            // @todo add user error handler
        }
        return response;
    };

export default getRefreshToken;
